/** Vista previa / texto de direccionCompleta a partir de ubicación estructurada. */
export const generarDireccionCompleta = ({
  manzana,
  lote,
  sector,
  distrito,
  departamento,
} = {}) => {
  const partes = [];
  const mz = String(manzana || '').trim();
  const lt = String(lote || '').trim();
  if (mz && lt) partes.push(`MZ. ${mz.toUpperCase()} LOTE ${lt.toUpperCase()}`);
  else if (mz) partes.push(`MZ. ${mz.toUpperCase()}`);
  else if (lt) partes.push(`LOTE ${lt.toUpperCase()}`);
  if (String(sector || '').trim()) partes.push(String(sector).trim().toUpperCase());
  if (String(distrito || '').trim()) partes.push(String(distrito).trim().toUpperCase());
  if (String(departamento || '').trim()) partes.push(String(departamento).trim().toUpperCase());
  return partes.length > 0 ? partes.join(', ') : '';
};
